import {
  DateTimeFormatter,
  Loader,
  getDateTimeFormat,
  getTranslatedText,
  useIntl,
  Editor,
  getHeaderValue,
  CustomMenu,
  CustomModal,
  IndicatorSeparator,
  DropdownIndicator,
  toast,
  useIsAuthorisedHook,
  TEXT_LENGTH,
  getCurrentUserHook,
  fetchApi,
  useProduct,
  COMMON_CONSTANTS
} from '@nile/components/src';
import {
  TextField,
  Popover,
  TextStyle,
  DateTimePicker,
  TimePicker,
  Checkbox,
  Badge,
  Card,
  Tabs,
  ActionList,
  Avatar,
  Dropdown,
  Tag,
  Button,
  Modal
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import React, { useContext, useEffect, useState } from 'react';
import AssociateWorkItem from '@nile/components/src/Containers/NewWorklog/AssociateWorkItem';
import {
  AccountClient,
  GET_CLIENT_USER_LIST,
  GET_TECHNICIANS_BY_CRITERIA,
  useLazyQuery,
  useQuery,
  GET_ADDRESS_LIST,
  CREATE_ADDRESS,
  useCachedQuery,
  GET_CALENDAR_VIEW_EVENTS,
  TicketClient,
  GET_APPOINTMENT_EVENT_DESCRIPTION
} from '@nile/graphql';
import { clone, cloneDeep, isEmpty } from 'lodash';
import Tippy from '@tippyjs/react';
import moment from 'moment';
import {
  reactSelectErrorStyles,
  reactSelectInlineError
} from '@nile/banyan/src/Utils/style';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { FormattedMessage } from 'react-intl';
import { getDayDetails } from '../helpers';
import dompurify from 'dompurify';
import envConfig from '@nile/home/src/Config/env';
import CreateAddressContainer from '../Containers/CreateAddressContainer';
import { useMutation } from '@apollo/client';
import CalendarSheet from '../../../Components/Calendar/CalanderSheet';
import AppointmentFormCalendar from './AppointmentFormCalendar';
import SchedulingContext from '../Contexts/SchedulingContext';
import { useStateList } from '@nile/components/src/Constants/stateslist/getstates';

import { components } from 'react-select';
import { GET_TICKET_DETAILS_FOR_FORM } from '@nile/graphql/src';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import { loggerInfo } from '@nile/home/src/coralogixRUM';
const { MultiValueRemove } = components;

const StyledTimePicker = styled(TimePicker)`
  .rc-time-picker-clear-icon {
    display: none;
    pointer-events: none;
  }
  .rc-time-picker-input {
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 0;
    color: #000;
    font-size: 14px;
    outline: none !important;
    border-bottom: none !important;
    background: ${(props) => props?.error && 'var(--sops-error-bg-color);'};
  }
`;

const DropdownList = (props) => {
  const { data, onSelect, selectedItems } = props;

  const currentUser = getCurrentUserHook();

  if (data && !isEmpty(data)) {
    return (
      <>
        {data.map((el) => {
          const initial = el?.value?.[0];
          const isSelected = selectedItems.find(
            (select) => select?.userId === el?.userId
          );
          const isCurrentUser = el?.userId === currentUser?.userId;

          return (
            <div
              className="flex g10 br10 custom-menu-option"
              onClick={() => onSelect(el)}
            >
              <span className={` ${isSelected ? 'avatar-selected' : ''}`}>
                <Avatar initials={initial} size="extraSmall" />
              </span>

              <div>
                <TextStyle>{el?.value}</TextStyle>
                {isCurrentUser && (
                  <span className="ml-5">
                    (
                    <FormattedMessage id="ticket.technicians.dropdown.isCurrentUser" />
                    )
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </>
    );
  }

  return <></>;
};

const AsyncSelectTechnicianAndRequesters = (props) => {
  const intl = useIntl();
  const currentProduct = useProduct();
  const isMSPProduct = currentProduct === COMMON_CONSTANTS.MSP;
  const [technicians, setTechnicians] = useState([]);
  const [requesters, setRequesters] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);

  const onTabChange = (index) => {
    setSelectedTab(index);
  };

  const client = props?.client;

  const [
    getClientUsers,
    { called, loading, data: requestersData, refetch }
  ] = useLazyQuery(GET_CLIENT_USER_LIST, {
    client: AccountClient,
    skip: isMSPProduct ? !client?.accountId : false,
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        clientId: client?.accountId,
        listInfo: {
          sort: {
            attribute: 'user.name',
            order: 'ASC'
          }
        }
      }
    }
  });

  const baseInput = {
    listInfo: {
      sort: {
        attribute: 'name',
        order: 'ASC'
      }
    }
  };

  const [
    getTechnicians,
    { loading: techLoading, data: techData, error }
  ] = useLazyQuery(GET_TECHNICIANS_BY_CRITERIA, {
    client: AccountClient,
    skip: isMSPProduct ? !client?.accountId : false,
    fetchPolicy: 'network-only',
    variables:
      currentProduct === COMMON_CONSTANTS.MSP
        ? {
            input: {
              ...baseInput,
              forOrganizations: [{ accountId: client?.accountId }]
            }
          }
        : { input: baseInput }
  });

  const callApis = () => {
    getTechnicians();
    getClientUsers();
  };

  useEffect(() => {
    if (techData?.getTechnicianList?.userList) {
      const formattedTechList = techData?.getTechnicianList?.userList?.map(
        (el) => ({
          ...el,
          id: el?.userId,
          value: el?.name,
          label: el?.name,
          type: 'technician'
        })
      );
      setTechnicians(formattedTechList);
    }
  }, [techData]);

  useEffect(() => {
    if (requestersData?.getClientUserAssociationsList?.associations) {
      const formattedReqList = requestersData?.getClientUserAssociationsList?.associations?.map(
        (el) => {
          el = el.user;
          return {
            ...el,
            id: el?.userId,
            value: el?.name,
            label: el?.name,
            type: 'requester'
          };
        }
      );
      setRequesters(formattedReqList);
    }
  }, [requestersData]);

  useEffect(() => {
    if (isMSPProduct) {
      if (props?.client) {
        callApis();
      }
    } else {
      callApis();
    }
  }, [props?.client]);

  const tabData = [
    {
      content: getTranslatedText(intl, 'ticket.details.header.req'),
      id: 'requester',
      panelID: 'Requester'
    },
    {
      content: getTranslatedText(intl, 'app.common.technician'),
      id: 'technician',
      panelID: 'Technician'
    }
  ];

  const getDropDownData = (id) => {
    switch (id) {
      case 0:
        return requesters;
      default:
        return technicians;
    }
  };

  const getIsDisabled = () => {
    if (props?.disabled) {
      return true;
    }
    if (isMSPProduct && isEmpty(client)) {
      return true;
    }
    return false;
  };

  const disabled = getIsDisabled();

  const TabMenu = (props) => {
    const selectedItems = props?.selectProps?.value;
    const searchTerm = props?.selectProps?.inputValue;
    let searchedItems = getDropDownData(selectedTab);

    if (searchTerm.trim()) {
      searchedItems = searchedItems.filter((el) => {
        const searchFields =
          el?.name?.toLowerCase() ||
          el?.label?.toLowerCase() ||
          el?.value?.toLowerCase();
        return searchFields.includes(searchTerm);
      });
    }

    return (
      <div
        ref={props?.innerRef}
        {...props?.innerProps}
        className="customReactSelectMenu br-10"
      >
        <Tabs
          fillWhiteBg
          onSelect={onTabChange}
          selected={selectedTab}
          tabs={tabData}
        >
          <div className="min-width-500 p10">
            {techLoading || loading ? (
              <div className="h-250 sops-overflow-auto">
                <Loader />
              </div>
            ) : (
              <div className="h-250 sops-overflow-auto">
                <DropdownList
                  data={searchedItems}
                  onSelect={props?.setValue}
                  selectedItems={selectedItems}
                />
              </div>
            )}
          </div>
        </Tabs>
      </div>
    );
  };

  const CustomMultiValueRemove = (props) => {
    const { data, ...rest } = props;
    const isRemovable = data?.attendeeType !== 'ORGANIZER';
    return isRemovable ? <MultiValueRemove {...rest} /> : null;
  };

  const OptionComponent = (props) => {
    const value =
      props?.name || props?.label || props?.value || props?.user?.email;
    const initial = value?.[0];
    return (
      <div className="flex g5 actr p5">
        <div>
          <Avatar initials={initial} size="extraSmall" />
        </div>
        <div className="nowrap">
          <TextStyle>{value}</TextStyle>
        </div>
      </div>
    );
  };

  return (
    <div className={`w100 ${disabled ? 'disabled' : ''}`}>
      <Dropdown
        classNamePrefix="value_selector"
        defaultValue={props?.selected}
        onChange={props?.onSelect}
        options={technicians}
        placeholder={getTranslatedText(
          intl,
          'scheduling.event.form.location.placeholder'
        )}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        isDisabled={disabled}
        components={{
          IndicatorSeparator,
          DropdownIndicator,
          Menu: TabMenu,
          MultiValueRemove: CustomMultiValueRemove
        }}
        value={props?.selected}
        isMulti
        isLoading={loading || techLoading}
        isClearable={false}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999
          }),
          multiValue: (provided, state) => ({
            ...provided,
            borderRadius: '5px',
            padding: '0px'
          }),
          valueContainer: (provided, state) => ({
            ...provided,
            maxHeight: '90px',
            overflow: 'auto !important'
          }),
          control: (provided, state) => ({
            ...provided,
            borderBottom: 'none !important'
          })
        }}
        formatOptionLabel={OptionComponent}
      />
    </div>
  );
};

const AsyncSelectSite = (props) => {
  const { client } = props;
  const intl = useIntl();
  const currentUser = getCurrentUserHook();

  const currentProduct = useProduct();
  const isMSPProduct = currentProduct === COMMON_CONSTANTS.MSP;

  const [options, setOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [addressSaveLoading, setAddressSaveLoading] = useState(false);
  const countries = useStateList('country');
  const states = useStateList('states');

  const clientId = isMSPProduct
    ? client?.accountId
    : currentUser?.associations?.[0]?.client?.accountId;

  const {
    loading,
    refetch: refetchAddress,
    data: addressData
  } = useCachedQuery(GET_ADDRESS_LIST, {
    client: AccountClient,
    skip: !clientId,
    variables: {
      input: {
        client: isMSPProduct
          ? {
              accountId: clientId
            }
          : undefined,
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    }
  });

  useEffect(() => {
    if (addressData?.getAddresses?.address) {
      const addresses = addressData?.getAddresses?.address || [];

      const externalItems = addresses
        .filter((item) => item.type === 'EXTERNAL')
        ?.map((el) => ({
          ...el,
          label: el?.name,
          value: el?.name
        }));
      const internalItems = addresses
        .filter((item) => item.type === 'INTERNAL')
        ?.map((el) => ({
          ...el,
          label: el?.name,
          value: el?.name
        }));

      const formattedSiteList = [
        {
          label: getTranslatedText(intl, 'scheduling.address.internal.label'),
          options: internalItems
        },
        {
          label: getTranslatedText(intl, 'scheduling.address.external.label'),
          options: externalItems
        }
      ];
      setOptions(formattedSiteList);
    }
  }, [addressData]);

  const [createAddress] = useMutation(CREATE_ADDRESS, {
    client: AccountClient,
    onCompleted(res) {}
  });

  const onAddressSave = (variablesInput) => {
    const {
      name,
      line1,
      line2,
      line3,
      city,
      postalCode,
      countryCode,
      stateCode
    } = variablesInput;
    setAddressSaveLoading(true);
    createAddress({
      variables: {
        input: {
          name,
          line1,
          line2,
          line3,
          city,
          postalCode,
          countryCode: countryCode?.isoCode,
          stateCode
        }
      }
    })
      .then((res) => {
        setAddressSaveLoading(false);
        setShowModal(false);
        toast('success', 'scheduling.address.create.success');
        const addedAddress = {
          ...res?.data?.createAddress,
          label: res?.data?.createAddress?.name,
          value: res?.data?.createAddress?.name
        };
        props?.onChange(addedAddress);

        refetchAddress().then((res) => {
          const addresses = res?.getAddresses?.address || [];
          const formattedSiteList = addresses?.map((el) => ({
            ...el,
            label: el?.name,
            value: el?.name
          }));
          setOptions(formattedSiteList);
        });
      })
      .catch((err) => {
        setAddressSaveLoading(false);
      });
  };

  const CustomMenuWithActions = (props) => {
    return (
      <>
        <CustomMenu
          {...props}
          actionComponent={
            <Button
              onClick={() => setShowModal(true)}
              plain
              icon={<SVGIcon name="Add" color="rgba(1, 31, 255, 1)" />}
            >
              {getTranslatedText(
                intl,
                'scheduling.event.form.address.create.buttonText'
              )}
            </Button>
          }
        />
      </>
    );
  };

  const OptionComponent = (props) => {
    const label = props?.name;
    const line1 = props?.line1;
    const line2 = props?.line2;
    const line3 = props?.line3;
    const postalCode = props?.postalCode;
    const countryCode = props?.countryCode;
    const stateCode = props?.stateCode;

    let description = null;

    if (line1) {
      if (description) {
        description = `${description}, ${line1}`;
      } else {
        description = `${line1}`;
      }
    }
    if (line2) {
      if (description) {
        description = `${description}, ${line2}`;
      } else {
        description = `${line2}`;
      }
    }
    if (line3) {
      if (description) {
        description = `${description}, ${line3}`;
      } else {
        description = `${line3}`;
      }
    }
    if (stateCode) {
      const state =
        states?.find(
          (st) => st.isoCode === stateCode && st.countryCode === countryCode
        )?.name || '';
      if (description) {
        description = `${description}, ${state}`;
      } else {
        description = `${state}`;
      }
    }
    if (countryCode) {
      const country =
        countries?.find((st) => st.isoCode === countryCode)?.name || '';
      if (description) {
        description = `${description}, ${country}`;
      } else {
        description = `${country}`;
      }
    }
    if (postalCode) {
      if (description) {
        description = `${description}, ${postalCode}`;
      } else {
        description = `${postalCode}`;
      }
    }

    return (
      <div>
        <div className="mb-2">
          <TextStyle>{label}</TextStyle>
        </div>
        <div className="select-address-description">
          <TextStyle variation="subdued">{description || 'NA'}</TextStyle>
        </div>
      </div>
    );
  };
  return (
    <div className={`w100 ${isEmpty(clientId) ? 'disabled' : ''}`}>
      <Dropdown
        isLoading={loading}
        classNamePrefix="value_selector"
        defaultValue={props?.selected}
        onChange={props?.onChange}
        options={options}
        placeholder={getTranslatedText(
          intl,
          'scheduling.event.form.location.placeholder'
        )}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        noOptionsMessage={() => {
          return loading ? 'Loading...' : 'No options';
        }}
        isDisabled={isEmpty(clientId)}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999
          }),
          control: (provided, state) => ({
            ...provided,
            borderBottom: 'none !important'
          })
        }}
        formatOptionLabel={OptionComponent}
        components={{
          Menu: CustomMenuWithActions,
          IndicatorSeparator,
          DropdownIndicator
        }}
        value={props?.selected}
        isClearable
      />

      <Modal
        open={showModal}
        locked
        showCloseButton={false}
        noScroll
        // fullScreen
      >
        {/* <div className="vw50 wm-700"> */}
        <CreateAddressContainer
          onCancel={() => {
            setShowModal(false);
          }}
          onSave={onAddressSave}
          saveLoading={addressSaveLoading}
        />
        {/* </div> */}
      </Modal>
    </div>
  );
};

const getTimeFromDate = (isoDateTime) => {
  const time = isoDateTime || new Date();
  const parsedDateTime = dayjs(time);
  const timeValue = parsedDateTime.format('HH:mm');
  return timeValue;
};

const formatDateAndTime = (dateString, timeString) => {
  const inputDate = dayjs(dateString);
  const [hours, minutes] = timeString.split(':');
  const result = inputDate.set('hour', hours).set('minute', minutes);
  // Format the date to 'YYYY-MM-DDTHH:mm:ss'
  const formattedDateTime = result.format('YYYY-MM-DDTHH:mm:ss');
  return formattedDateTime;
};

const AppointmentForm = (props) => {
  const DEFAULT_DATE = new Date();
  const intl = useIntl();

  const dateTimeFormat = getDateTimeFormat();
  const is12Hours = dateTimeFormat?.timeType === '12Hours';
  let timeFormatForTimePicker = dateTimeFormat?.MSPtimeFormat;
  if (timeFormatForTimePicker === 'hh:mm aa') {
    timeFormatForTimePicker = 'hh:mm A';
  }

  const schedulingContext = useContext(SchedulingContext);
  const workItemFromProps =
    schedulingContext?.workItemFromProps || props?.workItem;

  const [eventTitle, setEventTitle] = useState(props?.title || '');
  const [datepickerActive, setDatepickerActive] = useState(false);
  const [allDay, setAllDay] = useState(props?.allDay || false);

  const inputDate =
    props?.start || props?.startTime
      ? dayjs(props?.start || props?.startTime).toDate()
      : DEFAULT_DATE;
  const [selectedDate, setSelectedDate] = useState(inputDate);

  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [associatedWorkItem, setAssociatedWorkItem] = useState(
    props?.work || props?.workItem || null
  );
  const [selectedAddress, setSelectedAddress] = useState(
    props?.address || null
  );
  const [isFileUploading, setIsFileUploading] = useState(false);
  const editorRef = React.useRef(null);

  useEffect(() => {
    const modifiedInputDate =
      props?.start || props?.startTime
        ? dayjs(props?.start || props?.startTime).toDate()
        : DEFAULT_DATE;
    setSelectedDate(modifiedInputDate);
    const start = getTimeFromDate(props?.start || props?.startTime);
    const end = getTimeFromDate(props?.end || props?.endTime);
    setStartTime(start);
    setEndTime(end);
  }, [props.start, props.startTime]);

  useEffect(() => {
    const start = getTimeFromDate(props?.start || props?.startTime);
    const end = getTimeFromDate(props?.end || props?.endTime);
    setStartTime(start);
    setEndTime(end);
  }, []);

  const onTitleChange = (title) => {
    setEventTitle(title);
    if (props?.onDataChange) {
      props?.onDataChange('title', title);
    }
  };

  const toggleAllDay = (value) => {
    setAllDay(value);
    if (props?.onDataChange) {
      props?.onDataChange('allDay', value);
    }
  };

  const [getAppointmentEventDescription, { called, loading }] = useLazyQuery(
    GET_APPOINTMENT_EVENT_DESCRIPTION,
    {
      client: TicketClient,
      fetchPolicy: 'network-only',
      onCompleted(res) {
        if (res?.getAppointmentEventDescription) {
          const updatedContent = dompurifier(
            res?.getAppointmentEventDescription
          );
          editorRef.current.updateEditorContent(updatedContent);
        }
      }
    }
  );

  const [otherDetails, setOtherDetails] = useState(null);

  const getTicketDetails = (workItemId) => {
    let details = {};
    const currentAttendees = cloneDeep(selectedAttendees);
    const updatedAttendees = currentAttendees.filter(
      (el) => el?.attendeeType === 'ORGANIZER'
    );
    TicketClient.query({
      query: GET_TICKET_DETAILS_FOR_FORM,
      variables: {
        id: workItemId
      }
    }).then((res) => {
      const data = res?.data?.getTicket;
      const requester = data?.requester;
      const technician =
        data?.technician?.deletedTime === '0' && data?.technician; // Append only not deleted tech
      // If the technician is not deleted the deletedTime will be '0': string
      // If the technician is deleted the deletedTime will be timestamp '123123123': string
      details = {
        ...details,
        client: data?.client
      };
      if (!isEmpty(requester)) {
        const isRequesterPresent =
          updatedAttendees.findIndex(
            (el) => el?.user?.userId === requester?.userId
          ) > -1;
        if (!isRequesterPresent) {
          const requesterAttendee = {
            ...requester,
            id: requester?.userId,
            label: requester?.name,
            value: requester?.name,
            attendeeType: 'REQUIRED',
            acceptanceStatus: 'NONE'
          };
          updatedAttendees.push(requesterAttendee);
        }
      }

      if (!isEmpty(data?.site?.address)) {
        const address = data?.site?.address;
        const defaultAddress = {
          ...address,
          addressId: address?.addressId,
          id: address?.addressId,
          label: address?.name || '',
          value: address?.name || ''
        };
        setSelectedAddress(defaultAddress);
      }

      if (!isEmpty(technician)) {
        const isTechnicianPresent = updatedAttendees.find(
          (el) => el?.userId === technician?.userId
        );
        if (!isTechnicianPresent) {
          const technicianAttendee = {
            ...technician,
            id: technician?.userId,
            label: technician?.name,
            value: technician?.name,
            attendeeType: 'REQUIRED',
            acceptanceStatus: 'NONE'
          };
          updatedAttendees.push(technicianAttendee);
        }
      }
      setOtherDetails(data);
      setSelectedAttendees(updatedAttendees);
    });
  };

  const handleAssociateWorkItem = (module, workItem) => {
    setAssociatedWorkItem(workItem);
    const currentAttendees = cloneDeep(selectedAttendees);

    if (module === 'TICKET' && workItem?.workId) {
      getTicketDetails(workItem?.workId);
    } else {
      const updatedAttendees = currentAttendees.filter(
        (el) => el?.attendeeType === 'ORGANIZER'
      );
      let defaultAddress;
      if (!isEmpty(workItem?.site?.address)) {
        const address = workItem?.site?.address;
        defaultAddress = {
          ...address,
          addressId: address?.addressId,
          id: address?.addressId,
          label: address?.name || '',
          value: address?.name || ''
        };
      }
      setSelectedAttendees(updatedAttendees);
      setSelectedAddress(defaultAddress || null);
      setOtherDetails(null);
    }
    // setSelectedAddress(null);
    if (props?.onDataChange) {
      const updatedData = {
        workItem: {
          module: module,
          ...workItem
        },
        attendees: updatedAttendees
      };
      props?.onDataChange(null, null, updatedData);
    }
    getAppointmentEventDescription({
      variables: {
        input: {
          workItem: {
            workId: workItem?.workId,
            module: workItem?.module || module
          }
        }
      }
    });
  };

  const handleAssociateWorkItemFromProps = (module, workItem) => {
    setAssociatedWorkItem(workItem);
    if (!isEmpty(attendeesFromWorkItem)) {
      const updatedAttendees = [...selectedAttendees, ...attendeesFromWorkItem];
      setSelectedAttendees(updatedAttendees);
      if (props?.onDataChange) {
        props?.onDataChange('attendees', updatedAttendees);
      }
    }
    getAppointmentEventDescription({
      variables: {
        input: {
          workItem: {
            workId: workItem?.workId,
            module: workItem?.module || module
          }
        }
      }
    });
  };

  useEffect(() => {
    const module = workItemFromProps?.module;
    if (workItemFromProps && !props?.disableWorkitem) {
      handleAssociateWorkItem(module, workItemFromProps);
    }
  }, [workItemFromProps]);

  const onSelectAddress = (site) => {
    setSelectedAddress(site);
    if (props?.onDataChange) {
      props?.onDataChange('address', site);
    }
  };

  const attendeesFromWorkItem = !isEmpty(
    schedulingContext?.attendeesFromWorkItem
  )
    ? schedulingContext?.attendeesFromWorkItem.map((el) => ({
        ...el,
        label: el?.name,
        value: el?.name,
        attendeeType: 'REQUIRED',
        acceptanceStatus: 'NONE'
      }))
    : [];

  const [selectedAttendees, setSelectedAttendees] = useState(
    props?.attendees || []
  );

  const [template, setTemplate] = useState({
    name: '',
    content: dompurifier(props.description) || '',
    placeholdersUsed: '',
    mentions: [],
    attachments: props?.attachments || [],
    inlineImages: []
  });

  const onSelectInvites = (user) => {
    const prevSelected = cloneDeep(selectedAttendees);
    const isPresent =
      prevSelected.findIndex(
        (el) => el?.userId === user?.userId || el?.id === user?.id
      ) > -1;
    if (!isPresent) {
      setSelectedAttendees([
        ...prevSelected,
        { ...user, attendeeType: 'REQUIRED', acceptanceStatus: 'NONE' }
      ]);
      if (props?.onDataChange) {
        props?.onDataChange('attendees', [
          ...prevSelected,
          { ...user, attendeeType: 'REQUIRED', acceptanceStatus: 'NONE' }
        ]);
      }
    }
  };
  const onRemoveInvites = (user) => {
    const prevSelected = cloneDeep(selectedAttendees);
    const updatedInvites = prevSelected.filter(
      (el) => el?.userId !== user?.userId || el?.id !== user?.id
    );
    setSelectedAttendees(updatedInvites);
    if (props?.onDataChange) {
      props?.onDataChange('attendees', updatedInvites);
    }
  };

  const onAttendeesChange = (userData, data) => {
    const action = data?.action;
    const user = data?.removedValue || userData;

    if (action === 'remove-value') {
      onRemoveInvites(user);
    }

    if (action === 'set-value') {
      onSelectInvites(user);
    }
  };

  const updateTemplate = (obj) => {
    const clonedTemplate = cloneDeep(template);
    const updatedTemplate = { ...clonedTemplate, ...obj };
    setTemplate(updatedTemplate);
  };

  const handleFileAttachments = (fileInput, callback) => {
    const formData = new FormData();
    const files = [fileInput];
    files.forEach((file, idx) => {
      formData.append(`files`, file);
    });

    const attachmentUploadUrl = `${envConfig.fileRoot}/upload`;
    const uploadParams = {
      // module: 'TICKET',
      // details: JSON.stringify({ operation: 'CREATE' })
      module: 'CALENDAR_EVENT_ATTACHMENT',
      details: JSON.stringify({})
    };

    // if (template?.id) {

    for (const property in uploadParams) {
      formData.append(property, uploadParams[property]);
    }

    setIsFileUploading(true);

    const requestOptions = {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: getHeaderValue()
    };
    fetchApi(attachmentUploadUrl, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((response) => response.data)
      .then((list) => {
        const updatedList = [...list];
        setTemplate({
          ...template,
          attachments: updatedList
        });
        setIsFileUploading(false);
      })
      .catch((error) => {
        setIsFileUploading(false);
      })
      .finally(() => {
        setIsFileUploading(false);
        if (callback) {
          callback();
        }
      });
  };

  const handleAttachmentsDeletion = (fileName) => {
    const updatedList = cloneDeep(template?.attachments).filter(
      (item) => item.fileName !== fileName
    );
    setTemplate({ ...template, attachments: updatedList });
  };

  const [calendarSheetActive, setCalendarSheetActive] = useState(false);

  const [errors, setErrors] = useState(null);

  const validateForm = (start, end) => {
    let err = {};
    const formattedStart = dayjs(start);
    const formattedEnd = dayjs(end);
    const isEndTimeBeforeStart = formattedEnd.isBefore(formattedStart);
    if (isEndTimeBeforeStart) {
      err = {
        ...err,
        time: true
      };
    }

    if (isEmpty(err)) {
      return null;
    } else {
      return err;
    }
  };

  const onSave = () => {
    const dayDetails = getDayDetails(selectedDate);
    const formattedStartTime = allDay
      ? dayDetails?.startTime
      : formatDateAndTime(selectedDate, startTime);
    const formattedEndTime = allDay
      ? dayDetails?.endTime
      : formatDateAndTime(selectedDate, endTime);

    const organizer = selectedAttendees.find(
      (el) => el?.attendeeType === 'ORGANIZER'
    );

    const address = isEmpty(selectedAddress) ? null : selectedAddress;

    const validationErrors = validateForm(formattedStartTime, formattedEndTime);

    if (validationErrors) {
      setErrors(validationErrors);
    } else {
      if (!organizer?.user?.userId && organizer?.id) {
        // if (window?.logger) {
        //   window?.logger?.info(
        //     'Organizer not present: Data from appointment form',
        //     {
        //       eventDuration: {
        //         startTime: formattedStartTime,
        //         endTime: formattedEndTime,
        //         allDay: allDay
        //       },
        //       workItem: associatedWorkItem,
        //       organizer: organizer,
        //       subject: eventTitle,
        //       address: address,
        //       description: template?.content,
        //       attachments: template?.attachments,
        //       attendees: selectedAttendees
        //     }
        //   );
        //   window?.logger?.flush();
        // }
        loggerInfo('Organizer not present: Data from appointment form', {
          eventDuration: {
            startTime: formattedStartTime,
            endTime: formattedEndTime,
            allDay: allDay
          },
          workItem: associatedWorkItem,
          organizer: organizer,
          subject: eventTitle,
          address: address,
          description: template?.content,
          attachments: template?.attachments,
          attendees: selectedAttendees
        });
      }
      props?.onSave({
        eventDuration: {
          startTime: formattedStartTime,
          endTime: formattedEndTime,
          allDay: allDay
        },
        workItem: associatedWorkItem,
        organizer: organizer,
        subject: eventTitle,
        address: address,
        description: template?.content,
        attachments: template?.attachments,
        attendees: selectedAttendees
      });
    }
  };

  const isDispatcher = useIsAuthorisedHook('dispatcherCalendar.allow');

  const onCalendarSheetClose = (updatedTime) => {
    if (updatedTime?.start && updatedTime?.end) {
      const start = getTimeFromDate(updatedTime?.start);
      const end = getTimeFromDate(updatedTime?.end);
      setStartTime(start);
      setEndTime(end);
    }
    setCalendarSheetActive(false);
  };

  return (
    <>
      <div
        id="appointment-form"
        className="appointment-form p40 br10 width-600 relative pd-t0"
      >
        <div className="mb20 appointment-title-input">
          <TextField
            value={eventTitle}
            placeholder={getTranslatedText(
              intl,
              'scheduling.event.form.event.title.placeholder'
            )}
            onChange={(val) => onTitleChange(val)}
            maxLength={TEXT_LENGTH.size_5}
            fontSize="fontMedium"
          />
        </div>

        <div className="mb-20">
          <div className="flex fx-sb actr">
            <div id="date-picker" className="w60">
              <Popover
                activator={
                  <div
                    className="flex g5 actr pointer"
                    onClick={() => setDatepickerActive(!datepickerActive)}
                  >
                    <div className="mt3 fx">
                      <SVGIcon name="DatePicker" />
                    </div>
                    <div>
                      <TextStyle weight="SemiBold">
                        <DateTimeFormatter type="date" date={selectedDate} />
                      </TextStyle>
                    </div>
                    <div className="pt-5">
                      <SVGIcon name="ArrowDown" />
                    </div>
                  </div>
                }
                active={datepickerActive}
                onClose={() => setDatepickerActive(!datepickerActive)}
                fullHeight
                zIndexOverride={999999}
              >
                <div className="react-date-picker-no-box-shadow ">
                  <DateTimePicker
                    inline
                    popperPlacement="bottom"
                    shouldCloseOnSelect
                    dateFormat={dateTimeFormat?.dateFormat}
                    locale="enGb"
                    selectedDate={selectedDate}
                    selected={selectedDate}
                    onChange={(date) => {
                      setDatepickerActive(!datepickerActive);
                      setSelectedDate(date);
                    }}
                    minDate={props?.minDate}
                  />
                </div>
              </Popover>
            </div>

            <div className="flex g10 actr">
              <div>
                <SVGIcon name="ClockRound" />
              </div>
              <div>
                <StyledTimePicker
                  error={errors?.time}
                  showSecond={false}
                  use12Hours={is12Hours}
                  minuteStep={10}
                  popupClassName={'z-index-999999 appointment-form-timePicker'}
                  onChange={(val) => {
                    const time = val ? val.format('HH:mm') : '';
                    setStartTime(time);
                  }}
                  value={startTime ? moment(startTime, 'HH:mm a') : null}
                  format={timeFormatForTimePicker}
                  disabled={allDay}
                />
              </div>
              <div>-</div>
              <div>
                <StyledTimePicker
                  error={errors?.time}
                  showSecond={false}
                  use12Hours={is12Hours}
                  minuteStep={10}
                  popupClassName={'z-index-999999 appointment-form-timePicker'}
                  value={endTime ? moment(endTime, 'HH:mm a') : null}
                  dateFormat={dateTimeFormat?.timeFormat}
                  onChange={(val) => {
                    const time = val ? val.format('HH:mm') : '';
                    setEndTime(time);
                  }}
                  format={timeFormatForTimePicker}
                  disabled={allDay}
                />
              </div>
            </div>
          </div>

          <div className="mt-10">
            <Checkbox
              checked={allDay}
              label={getTranslatedText(
                intl,
                'scheduling.event.form.markAllDay.label'
              )}
              onChange={(value) => {
                toggleAllDay(value);
              }}
            />
          </div>
          <div></div>
        </div>

        <div
          className={`flex g10 mb-20 w100 ${
            props?.disableWorkitem ? 'disabled cursor-not-allowed ' : ''
          }`}
        >
          <AssociateWorkItem
            associatedWorkItem={associatedWorkItem}
            reAssociateWorkItem={props?.disableWorkitem ? false : true}
            handleAssociateWorkItem={
              props?.disableWorkitem ? () => {} : handleAssociateWorkItem
            }
            showSla
            otherDetails={otherDetails}
          />
        </div>

        <div className="flex g10 mb-10 actr">
          <div>
            <SVGIcon name="UserGroup" />
          </div>
          <div className="w100">
            <AsyncSelectTechnicianAndRequesters
              client={associatedWorkItem?.client}
              onSelect={onAttendeesChange}
              selected={selectedAttendees}
              disabled={props?.disableAttendees}
            />
          </div>
        </div>
        {isDispatcher && associatedWorkItem && selectedAttendees?.length > 1 && (
          <div className="mb-20 flex jend">
            <Button
              plain
              disabled={!associatedWorkItem}
              onClick={() => {
                setCalendarSheetActive(true);
              }}
            >
              {getTranslatedText(intl, 'timesheet.calendarTable.viewCalendar')}
            </Button>
            {calendarSheetActive && (
              <AppointmentFormCalendar
                active={calendarSheetActive}
                date={dayjs(selectedDate).format('YYYY-MM-DD')}
                setActive={setCalendarSheetActive}
                onClose={onCalendarSheetClose}
                attendees={selectedAttendees}
                events={[
                  {
                    start: new Date(
                      `${formatDateAndTime(selectedDate, startTime)}`
                    ),
                    end: new Date(
                      `${formatDateAndTime(selectedDate, endTime)}`
                    ),
                    eventType: 'BLOCK_EVENT'
                  }
                ]}
              />
            )}
          </div>
        )}

        <div className="flex g10 mb-20 actr">
          <div>
            <SVGIcon name="Location" />
          </div>
          <AsyncSelectSite
            client={associatedWorkItem?.client}
            onSelect={onSelectAddress}
            onChange={onSelectAddress}
            selected={selectedAddress}
          />
        </div>

        <div className="flex g10 mb-20">
          <div>
            <SVGIcon name="Notes" />
          </div>
          <div className="appointment-form w100 divider">
            <Editor
              // focusEditor
              editorRef={editorRef}
              template={template}
              updateTemplate={updateTemplate}
              module={'TICKET'}
              // details={details}
              handleFileAttachments={handleFileAttachments}
              handleAttachmentsDeletion={handleAttachmentsDeletion}
              title={getTranslatedText(intl, 'common.addAttachments')}
              description={getTranslatedText(
                intl,
                'common.upload.or.drop.files.max.3mb'
              )}
              config={{
                htmlUntouched: true,
                toolbarButtons: {
                  moreText: {},
                  moreParagraph: {},
                  moreRich: {
                    buttons: ['insertLink', 'attachFile'],
                    buttonsVisible: 2
                  },
                  moreMisc: {}
                }
              }}
              isUploading={isFileUploading}
              singleFile
              acceptAllType
            />
          </div>
        </div>

        <div className="flex g10">
          <Button
            plain
            onClick={onSave}
            loading={props?.saveLoading}
            disabled={
              isEmpty(eventTitle) ||
              isEmpty(associatedWorkItem) ||
              isEmpty(startTime) ||
              isEmpty(endTime) ||
              isEmpty(selectedAttendees)
            }
          >
            <FormattedMessage id="common.save" />
          </Button>
          <Button plainSecondary onClick={props?.onCancel}>
            <FormattedMessage id="common.cancel" />
          </Button>
        </div>
      </div>
    </>
  );
};

export default AppointmentForm;
